import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { routes } from 'client/lib/routes';
import { Channel } from 'client/model/skill';

export const useIsDraft = (channel: Channel, installableAppId = '') => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const isDraft = (pathname || '').startsWith(routes.app.installableAppSettings(channel, true, '', installableAppId));
    const setIsDraft = useCallback(
        (isDraftUpdated: boolean, channel: Channel) => {
            navigate(`${routes.app.appPage(channel, isDraftUpdated, 'settings', installableAppId)}/main`);
        },
        [installableAppId, navigate],
    );
    return { isDraft, setIsDraft };
};

export const useSkillIsDraft = (skillId = '') => {
    const { pathname = '' } = useLocation();
    const navigate = useNavigate();
    const isDraft = pathname.startsWith(routes.app.skillPage(true, '', skillId));
    const setIsDraft = useCallback(
        (isDraftUpdated: boolean) => {
            navigate(
                pathname.replace(
                    routes.app.skillPage(!isDraftUpdated, '', skillId),
                    routes.app.skillPage(isDraftUpdated, '', skillId),
                ),
            );
        },
        [skillId, navigate, pathname],
    );
    return { isDraft, setIsDraft };
};
